<template>
    <div
        class="tw-animate-pulse tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-flex-nowrap tw-py-5 tw-px-4 xl:tw-px-7 tw-relative tw-rounded-xl tw-mb-[15px] tw-border tw-border-[#E0E0E1] dark:tw-border-[#162939] tw-rounded-xl tw-bg-white dark:tw-bg-[#001729]"
    >
        <!-- Thumbnail -->
        <div class="sm:tw-flex-shrink-0 tw-w-full sm:tw-w-[150px] md:tw-w-[200px] xl:tw-w-[310px] tw-rounded-xl tw-overflow-hidden tw-relative tw-group sm:tw-pb-0 tw-mb-4 sm:tw-mb-0 tw-aspect-video tw-bg-[#F2F2F2] dark:tw-bg-[#002039]"></div>
        <div class="sm:tw-flex tw-grow tw-items-center tw-w-full">
            <div class="sm:tw-px-4 tw-grow tw-mb-3 sm:tw-mb-0">
                <div class="tw-flex tw-justify-between tw-w-full sm:tw-w-auto tw-items-start tw-mb-2">
                    <!-- Title -->
                    <div class="tw-w-52 tw-h-[30px] tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full"></div>
                    <!-- Add to playlist  -->
                    <div class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full sm:tw-hidden tw-p-0.5 tw-w-[26px] tw-h-[26px]"></div>
                </div>
                <!-- Description -->
                <div class="tw-hidden xl:tw-block lg:tw-mr-14 tw-mt-2 tw-mb-2 tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-w-2/3 tw-h-5 tw-rounded-full"></div>
                <!-- Artist -->
                <div class="tw-mb-2 tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-w-32 tw-h-5 tw-rounded-full"></div>
                <!-- Info -->
                <div class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-w-40 tw-h-5 tw-rounded-full"></div>
            </div>
            <div class="sm:tw-flex tw-flex-shrink-0 tw-items-center">
                <!-- Add to playlist -->
                <div class="tw-mr-3 tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full tw-w-[45px] tw-h-[45px] tw-hidden sm:tw-flex"></div>
                <!-- Action button -->
                <div class="tw-flex tw-items-center tw-mt-3 sm:tw-mt-0">
                    <div class="tw-mb-0 tw-flex-grow action tw-h-[45px] tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full"></div>
                </div>
            </div>
        </div>
    </div>
</template>
